import React from 'react';
import {uniqueId} from 'lodash';
import classnames from 'classnames';
import Icon from 'shared/components/icon';
import styles from './header.module.scss';

interface ThProps {
  colSpan?: number;
  rowSpan?: number;
  scope?: string;
  'aria-sort'?: 'ascending' | 'descending' | 'none' | 'other';
}

interface Column {
  value: string | React.ReactNode;
  thProps?: ThProps;
  // The following props are only required when the column is sortable
  sort?: boolean | null;
  onSort?: () => void;
  sortDirection?: 'ascending' | 'descending' | 'none' | null;
}

interface Props {
  centerText?: boolean;
  columns: Column[];
}

const Header = ({centerText, columns}: Props): React.ReactElement => (
  <thead className={styles.thead}>
    <tr className={styles.header}>
      {columns.map(({thProps, value, sort, onSort, sortDirection}) => {
        const additionalProps: Partial<React.HTMLProps<HTMLTableHeaderCellElement>> = {};

        if (sort) {
          additionalProps['aria-sort'] = sortDirection || 'none';
          additionalProps.onClick = onSort;
        }

        return (
          <th
            {...thProps}
            {...additionalProps}
            key={uniqueId('table-header-data')}
            className={classnames(styles.th, {
              [styles.center]: centerText,
              [styles.pointer]: onSort,
            })}
            data-testid="header-th"
          >
            {value}
            {sort && !sortDirection && <Icon iconType="sort" className={styles.icon} />}
            {sort && sortDirection === 'ascending' && (
              <Icon iconType="sort-down" className={styles.icon} />
            )}
            {sort && sortDirection === 'descending' && (
              <Icon iconType="sort-up" className={styles.icon} />
            )}
          </th>
        );
      })}
    </tr>
  </thead>
);

export default Header;
